import { STROKE_TTL_MS, type ClientStrokeSnapshot, type ServerStrokeSnapshot } from "@canvas/contracts";

export const MAX_STICKERS_PER_CLIENT = 5;
type Snapshot = ClientStrokeSnapshot | ServerStrokeSnapshot;
type Placement = { id: string; at: number };

// Keep the five newest placements even after their images fade. A delayed
// HTTP reply or websocket replay must not bring a replaced sticker back.
export class StickerWindow {
  private clients = new Map<string, { placements: Placement[]; expires: number }>();

  accept(snapshot: Snapshot, now: number): string[] {
    if (!snapshot.style.sticker) return [];
    const previous = this.clients.get(snapshot.clientId);
    const placements = previous && previous.expires > now ? previous.placements : [];
    const existing = placements.find(item => item.id === snapshot.strokeId);
    if (!existing) placements.push({ id: snapshot.strokeId, at: Date.parse(snapshot.clientUpdatedAt) });
    placements.sort((a, b) => a.at - b.at || (a.id < b.id ? -1 : a.id > b.id ? 1 : 0));
    const removed = placements.splice(0, Math.max(0, placements.length - MAX_STICKERS_PER_CLIENT));
    this.clients.set(snapshot.clientId, { placements, expires: now + STROKE_TTL_MS });
    return removed.map(item => item.id);
  }

  prune(now: number): void {
    for (const [id, entry] of this.clients) if (entry.expires <= now) this.clients.delete(id);
  }

  clear(): void { this.clients.clear(); }
}
